import {
  Typography,
  TextField,
  Button,
  Box,
  Paper,
} from "@mui/material";
import { useState, useEffect } from "react";
import SendIcon from "@mui/icons-material/Send";
import ContextoValidation from "../../utils/contextoValidation";
import { getReadonlyFlag } from "../../utils/getRoleToken";

const Contexto = ({
  nomeContexto = "",
  conteudoContexto = null,
  setDeveUpdateContexto = () => {},
  produto = "AC",
  nomeExibicao = "Informações adicionais",
  rows = 8,
  minEditorHeight = 220,
}) => {
  const [contexto, setContexto] = useState(conteudoContexto || "");
  const [contextoOriginal, setContextoOriginal] = useState(conteudoContexto || "");
  const [validationModalOpen, setValidationModalOpen] = useState(false);

  useEffect(() => {
    setContexto(conteudoContexto || "");
    setContextoOriginal(conteudoContexto || "");
  }, [conteudoContexto]);

  const hasChanges = contexto !== contextoOriginal;
  const readonly = getReadonlyFlag() === true;

  const shouldEnableButton = () => {
    const hasContent = contexto.length > 0;

    if (!contextoOriginal) {
      return hasContent;
    }

    return hasChanges && hasContent;
  };

  const handleEnviarContexto = () => {
    setValidationModalOpen(true);
  };

  const handleConfirmContexto = async (dadosAlteracao) => {
    try {
      console.log("Contexto confirmado:", dadosAlteracao);
      setContextoOriginal(contexto);
      setDeveUpdateContexto(true);
    } catch (error) {
      console.error("Erro ao processar confirmação:", error);
    }
  };

  const handleResetChanges = () => {
    setContexto(contextoOriginal);
  };

  return (
    <>
      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "background.paper",
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          {nomeExibicao}
        </Typography>

        <Box sx={{ position: "relative" }}>
          <TextField
            multiline
            rows={rows}
            fullWidth
            value={contexto}
            onChange={(e) => setContexto(e.target.value)}
            placeholder={conteudoContexto ? null : "Digite aqui a nova configuração..."}
            disabled={readonly}
            variant="outlined"
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                backgroundColor: "background.default",
                color: "text.primary",
                alignItems: "flex-start",
                "&.Mui-focused": {
                  backgroundColor: "background.paper",
                },
                "& fieldset": {
                  borderColor: "divider",
                },
                "&:hover fieldset": {
                  borderColor: "primary.main",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                },
              },
              "& .MuiOutlinedInput-input": {
                fontSize: "14px",
                lineHeight: 1.6,
                color: "text.primary",
              },
              "& textarea": {
                minHeight: minEditorHeight,
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: (theme) => theme.palette.text.primary,
                opacity: 0.72,
              },
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              mt: 1,
            }}
          >
            {contextoOriginal && hasChanges && !readonly && (
              <Button
                variant="outlined"
                onClick={handleResetChanges}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  px: 3,
                  py: 1,
                }}
              >
                Desfazer
              </Button>
            )}

            {!readonly && <Button
              variant="contained"
              endIcon={<SendIcon />}
              onClick={handleEnviarContexto}
              disabled={!shouldEnableButton()}
              sx={{
                backgroundColor: "primary.main",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
                "&:disabled": {
                  backgroundColor: "action.disabledBackground",
                  color: "text.disabled",
                },
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1,
              }}
            >
              {contextoOriginal ? "Atualizar" : "Enviar"}
            </Button>}
          </Box>
        </Box>
      </Paper>

      <ContextoValidation
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        nomeContexto={nomeContexto}
        contexto={contexto}
        onConfirm={handleConfirmContexto}
        produto={produto}
      />
    </>
  );
};

export default Contexto;
